import type { PartialPropsOf } from '@blaze-runtime/engine-domain';

import type { PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const checkboxV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Checkbox element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'checkbox'>): void => {
    const checkboxProps = props;

    if (checkboxProps?.style?.general?.title && !checkboxProps?.content?.title?.iconColor) {
      const currentColor = checkboxProps.style.general.title.color1;
      checkboxProps.content = {
        ...checkboxProps.content,
        title: {
          ...checkboxProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
